import { useState, useEffect } from 'react';
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import PageTitle from 'src/components/PageTitle';
import { useParams } from 'react-router-dom';

import {
  ICompanyBusinessLicense,
  ICompanyBusinessLicenseResponse,
} from 'src/Types/module/member/CompanyInformation';
import ModalsWrapper from 'src/components/Modals/ModalsWrapper';
import CompanyBusinessLicense from '../../../CompanyAddInfo/UpdateCompanyInformation/CompanyBusinessLicense';
import OtherBusinessLicense from '../../../CompanyAddInfo/CompanyAddInfoComponents/OtherBusinessLicense';
import GlobalLoader from 'src/components/SuspenseLoader/GlobalLoader';
import { HttpClient } from 'src/Helpers/http/http';
import PdfAndImageView from 'src/components/pdfAndImageView/PdfAndImageView';
import { CommonTypoGraphy } from 'src/components/pdfAndImageView/CommonTypoGraphy';

function BusinessLicenseInfo() {
  const { memberId } = useParams();
  const [open, setOpen] = useState<boolean>(false);
  const [businessLicense, setBusinessLicense] =
    useState<ICompanyBusinessLicense>({} as ICompanyBusinessLicense);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [imageViewOpen, SetImageViewOpen] = useState<boolean>(false);
  const [imageFile, setImageFile] = useState<string | null>('');

  useEffect(() => {
    setLoading(true);
    (async function () {
      try {
        const data: ICompanyBusinessLicenseResponse = await HttpClient.get(
          `/api/atab/admin/member-company/member/business-other-license/${memberId}`
        );
        if (data.success) {
          setBusinessLicense(data.data);
          setLoading(false);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    })();
  }, [memberId, refresh]);

  const { companyAssociationMembership, companyBusinessLicense } =
    businessLicense || {};

  const {
    association_membership_id,
    baira_membership,
    haab_membership,
    baira_membership_file,
    company_id,
    haab_membership_file,
    iata_membership,
    iata_membership_file,
    tdab_membership,
    tdab_membership_file,

    toab_membership,
    toab_membership_file,
  } = companyAssociationMembership || {};

  const {
    hajj_license,
    hajj_license_file,
    iata_agent,
    inbound,
    outbound,
    recruting_license,
    recruting_license_file,
    tickting,
    tourism,
    umrah_license,
    umrah_license_file,
  } = companyBusinessLicense || {};

  console.log(hajj_license);
  return (
    <>
      {/* {applied ? ( */}
      <>
        <PageTitleWrapper>
          <PageTitle
            heading='Business license information'
            actionButtonTitle={
              hajj_license ||
              umrah_license ||
              recruting_license ||
              inbound ||
              outbound
                ? 'Update'
                : 'Add'
            }
            setAction={setOpen}
          />
        </PageTitleWrapper>
        {loading ? (
          <GlobalLoader />
        ) : (
          <>
            <Grid sx={{ pb: 5 }} container spacing={2}>
              <Grid item xs={12} md={6}>
                <TableContainer component={Paper}>
                  <Table aria-label='custom pagination table'>
                    <TableBody>
                      <TableRow>
                        <TableCell component='th' scope='row'>
                          Hajj license:
                        </TableCell>
                        <TableCell align='right'>
                          {hajj_license ? 'Yes' : 'No'}
                        </TableCell>
                      </TableRow>

                      {hajj_license ? (
                        <TableRow>
                          <TableCell component='th' scope='row'>
                            Certificate of HAJJ :
                          </TableCell>
                          <TableCell align='right'>
                            {hajj_license_file ? (
                              <CommonTypoGraphy
                                name='View'
                                onClick={() => {
                                  SetImageViewOpen(true);
                                  setImageFile(hajj_license_file);
                                }}
                              />
                            ) : (
                              'Not provided'
                            )}
                          </TableCell>
                        </TableRow>
                      ) : (
                        ''
                      )}

                      <TableRow>
                        <TableCell component='th' scope='row'>
                          Umrah license:
                        </TableCell>
                        <TableCell align='right'>
                          {umrah_license ? 'Yes' : 'No'}
                        </TableCell>
                      </TableRow>

                      {umrah_license ? (
                        <TableRow>
                          <TableCell component='th' scope='row'>
                            Certificate of UMRA:
                          </TableCell>
                          <TableCell align='right'>
                            {umrah_license_file ? (
                              <CommonTypoGraphy
                                name='View'
                                onClick={() => {
                                  SetImageViewOpen(true);
                                  setImageFile(umrah_license_file);
                                }}
                              />
                            ) : (
                              'Not provided'
                            )}{' '}
                          </TableCell>
                        </TableRow>
                      ) : (
                        ''
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid item xs={12} md={6}>
                <TableContainer component={Paper}>
                  <Table aria-label='custom pagination table'>
                    <TableBody>
                      <TableRow>
                        <TableCell component='th' scope='row'>
                          Recruiting license :
                        </TableCell>
                        <TableCell align='right'>
                          {recruting_license ? 'Yes' : 'No'}
                        </TableCell>
                      </TableRow>
                      {recruting_license ? (
                        <TableRow>
                          <TableCell component='th' scope='row'>
                            Certificate of Recruiting:
                          </TableCell>
                          <TableCell align='right'>
                            {recruting_license_file ? (
                              <CommonTypoGraphy
                                name='View'
                                onClick={() => {
                                  SetImageViewOpen(true);
                                  setImageFile(recruting_license_file);
                                }}
                              />
                            ) : (
                              'Not provided'
                            )}{' '}
                          </TableCell>
                        </TableRow>
                      ) : (
                        ''
                      )}

                      <TableRow>
                        <TableCell component='th' scope='row'>
                          Tourism activities inbound :
                        </TableCell>
                        <TableCell align='right'>
                          {inbound === 1 ? 'Yes' : 'No'}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component='th' scope='row'>
                          Tourism activities outbound:
                        </TableCell>
                        <TableCell align='right'>
                          {outbound === 1 ? 'Yes' : 'No'}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </>
        )}
      </>

      <>
        <Grid sx={{ pb: 5 }} container spacing={2}>
          <Grid item xs={12} md={6}>
            <TableContainer component={Paper}>
              <Table aria-label='custom pagination table'>
                <TableBody>
                  <TableRow>
                    <TableCell component='th' scope='row'>
                      Membership of BAIRA:
                    </TableCell>
                    <TableCell align='right'>
                      {baira_membership ? 'Yes' : 'No'}{' '}
                    </TableCell>
                  </TableRow>

                  {baira_membership ? (
                    <TableRow>
                      <TableCell component='th' scope='row'>
                        Certificate of BAIRA :
                      </TableCell>
                      <TableCell align='right'>
                        {baira_membership_file ? (
                          <CommonTypoGraphy
                            name='View'
                            onClick={() => {
                              SetImageViewOpen(true);
                              setImageFile(baira_membership_file);
                            }}
                          />
                        ) : (
                          'Not provided'
                        )}
                      </TableCell>
                    </TableRow>
                  ) : (
                    ''
                  )}

                  <TableRow>
                    <TableCell component='th' scope='row'>
                      Membership of HAAB:
                    </TableCell>
                    <TableCell align='right'>
                      {haab_membership ? 'Yes' : 'No'}{' '}
                    </TableCell>
                  </TableRow>

                  {haab_membership ? (
                    <TableRow>
                      <TableCell component='th' scope='row'>
                        Certificate of HAAB:
                      </TableCell>
                      <TableCell align='right'>
                        {haab_membership_file ? (
                          <CommonTypoGraphy
                            name='View'
                            onClick={() => {
                              SetImageViewOpen(true);
                              setImageFile(haab_membership_file);
                            }}
                          />
                        ) : (
                          'Not provided'
                        )}{' '}
                      </TableCell>
                    </TableRow>
                  ) : (
                    ''
                  )}

                  <TableRow>
                    <TableCell component='th' scope='row'>
                      Membership of IATA:
                    </TableCell>
                    <TableCell align='right'>
                      {iata_membership ? 'Yes' : 'No'}{' '}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12} md={6}>
            <TableContainer component={Paper}>
              <Table aria-label='custom pagination table'>
                <TableBody>
                  {iata_membership ? (
                    <TableRow>
                      <TableCell component='th' scope='row'>
                        Certificate of IATA:
                      </TableCell>
                      <TableCell align='right'>
                        {iata_membership_file ? (
                          <CommonTypoGraphy
                            name='View'
                            onClick={() => {
                              SetImageViewOpen(true);
                              setImageFile(iata_membership_file);
                            }}
                          />
                        ) : (
                          'Not provided'
                        )}{' '}
                      </TableCell>
                    </TableRow>
                  ) : (
                    ''
                  )}

                  <TableRow>
                    <TableCell component='th' scope='row'>
                      Membership of TOAB :
                    </TableCell>
                    <TableCell align='right'>
                      {toab_membership ? 'Yes' : 'No'}{' '}
                    </TableCell>
                  </TableRow>
                  {toab_membership ? (
                    <TableRow>
                      <TableCell component='th' scope='row'>
                        Certificate of TOAB:
                      </TableCell>
                      <TableCell align='right'>
                        {toab_membership_file ? (
                          <CommonTypoGraphy
                            name='View'
                            onClick={() => {
                              SetImageViewOpen(true);
                              setImageFile(toab_membership_file);
                            }}
                          />
                        ) : (
                          'Not provided'
                        )}{' '}
                      </TableCell>
                    </TableRow>
                  ) : (
                    ''
                  )}

                  <TableRow>
                    <TableCell component='th' scope='row'>
                      Membership of TDAB :
                    </TableCell>
                    <TableCell align='right'>
                      {tdab_membership ? 'Yes' : 'No'}{' '}
                    </TableCell>
                  </TableRow>
                  {tdab_membership ? (
                    <TableRow>
                      <TableCell component='th' scope='row'>
                        Certificate of TOAB:
                      </TableCell>
                      <TableCell align='right'>
                        {tdab_membership_file ? (
                          <CommonTypoGraphy
                            name='View'
                            onClick={() => {
                              SetImageViewOpen(true);
                              setImageFile(tdab_membership_file);
                            }}
                          />
                        ) : (
                          'Not provided'
                        )}{' '}
                      </TableCell>
                    </TableRow>
                  ) : (
                    ''
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </>

      <ModalsWrapper
        setShowModal={setOpen}
        showModal={open}
        modalData={{
          title:
            hajj_license ||
            umrah_license ||
            recruting_license ||
            inbound ||
            outbound
              ? 'Update business license information'
              : 'Add business license information',
        }}
      >
        {hajj_license ||
        umrah_license ||
        recruting_license ||
        inbound ||
        outbound ? (
          <CompanyBusinessLicense
            memberId={memberId}
            otherBusiness={businessLicense}
            setRefresh={setRefresh}
            setOpen={setOpen}
            refresh={refresh}
          />
        ) : (
          <OtherBusinessLicense
            memberId={memberId}
            setRefresh={setRefresh}
            setOpen={setOpen}
            refresh={refresh}
          />
        )}
      </ModalsWrapper>

      <PdfAndImageView
        setOpen={SetImageViewOpen}
        open={imageViewOpen}
        file={imageFile}
      />
    </>
  );
}

export default BusinessLicenseInfo;
